var path = '/templates/projects.campaigns/views/directives/campaign_coupon_data.html';
var html = "<div ng-if=project.enables_coupon_code_conversion_tag><div ng-if=\"project.shows_coupon_code_usage_rate || Devise.isMaster()\"><i ng-if=!project.shows_coupon_code_usage_rate class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignCouponData.kuuponkoodo_shiyouritsu' | translate: { campaign_coupon_used_rate: rate_to_display } }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_coupon_data.html
// module id = 1361
// module chunks = 0